import { useCallback, useRef } from "react";
import type { UseFlashRippleArgs } from "./types";

const RIPPLE_DURATION_MS = 2000;
const RIPPLE_TRIGGER_CLASS = "bbox-ripple-trigger";

export const useFlashRipple = ({
  svgOverlayRef,
}: UseFlashRippleArgs): (() => void) => {
  const rippleTimeoutRef = useRef<number | null>(null);

  const flashRipple = useCallback(() => {
    const overlay = svgOverlayRef.current;
    if (!overlay) return;

    if (rippleTimeoutRef.current !== null) {
      clearTimeout(rippleTimeoutRef.current);
      overlay.classList.remove(RIPPLE_TRIGGER_CLASS);
      // Force reflow so the CSS keyframe restarts from 0% on the next add.
      void overlay.offsetWidth;
    }

    overlay.classList.add(RIPPLE_TRIGGER_CLASS);

    rippleTimeoutRef.current = window.setTimeout(() => {
      svgOverlayRef.current?.classList.remove(RIPPLE_TRIGGER_CLASS);
      rippleTimeoutRef.current = null;
    }, RIPPLE_DURATION_MS);
  }, [svgOverlayRef]);

  return flashRipple;
};
